if (!location.origin) {
	// Port is left out intentionally. IE sometimes reports 80 or 443 when it should be ''.
	(location as any).origin = `${location.protocol}//${location.hostname}`;
}
